import {
	axiosWithAuth,
	convertDateToISO,
	TIME_OFFSET_DAY_END,
} from "../../helpers";

export const merchantDepositsTabService = {
	getDepositsList,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getDepositsList({ page, sortBy, filters }, id) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${id}/deposits`,
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
			deposit_amount: filters?.depositAmount,
			deposit_date_from: convertDateToISO(filters?.depositDate?.[0]),
			deposit_date_to: convertDateToISO(filters?.depositDate?.[1], {
				addTime: TIME_OFFSET_DAY_END,
			}),
			report_date_from: convertDateToISO(filters?.reportDate?.[0]),
			report_date_to: convertDateToISO(filters?.reportDate?.[1], {
				addTime: TIME_OFFSET_DAY_END,
			}),
		},
	};

	return axiosWithAuth(options);
}
